var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlotCardIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.6943C4 12.7166 4.70683 11.8822 5.6712 11.7215L49.6712 4.38813C50.8903 4.18496 52 5.12504 52 6.36092V42.3057C52 43.2834 51.2932 44.1178 50.3288 44.2785L6.3288 51.6119C5.10973 51.815 4 50.875 4 49.6391V13.6943Z",
    fill: "#DFE2E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.6943C8.5 16.961 9.03012 16.3352 9.7534 16.2147L53.7534 8.88133C54.6677 8.72895 55.5 9.43401 55.5 10.3609V46.3057C55.5 47.039 54.9699 47.6648 54.2466 47.7853L10.2466 55.1187C9.3323 55.2711 8.5 54.566 8.5 53.6391V17.6943Z",
    fill: "#DFFBE8",
    stroke: "#00004B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20L52 13V44L12 51V20Z",
    stroke: "#00004B",
    strokeLinecap: "square",
    strokeDasharray: "1 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotCardIcon2);
export default __webpack_public_path__ + "static/media/PlotCardIcon2.6c8e58fcb46918f750ba6e7f15fa9bb7.svg";
export { ForwardRef as ReactComponent };